import { call, put } from '@redux-saga/core/effects';
import { logoutThunk } from '../../features/auth/services/authThunks';
import { appManagerActions } from '../appManager/actions';

export const createRequestQuery = (queries) => {
  let query = '?';
  const keys = Object.keys(queries);

  keys.forEach((element, i) => {
    query += element + '=' + queries[element];
    if (i < keys.length - 1) {
      query += '&';
    }
  });

  return query;
};

export default function* onErrorLogout(error) {
  if (!error) {
    return null;
  }
  if (error.request) {
    const {
      request: { status },
    } = error;

    if (status === 401) {
      yield put(logoutThunk());
    } else {
      return;
    }
  } else {
    return;
  }
}

export function* historyRedirect(navigate, link) {
  // disable prompt form on routing
  yield put(appManagerActions.formIsSubmitted.true());

  yield call(navigate, link);

  // enable prompt form on routing
  yield put(appManagerActions.formIsSubmitted.false());
}
